import React, { Component } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { User } from "../../generated";
import { Edit } from "@mui/icons-material";
import { TesterType } from "../../generated/models/TesterType";

export class UserInformation extends Component<
  {
    onEdit?: (user: User) => void;
    allowEdit?: boolean;
    allowDelete?: boolean;
    user: User;
  },
  {}
> {
  render() {
    return (
      <div
        className="border rounded rounded-more overflow-hidden p-5"
        style={{ fontSize: "0.75em" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2 className="mb-3">Additional information </h2>
          <p>
            {this.props.allowEdit !== false && (
              <Tooltip title="Edit" style={{ marginTop: "-3px" }}>
                <IconButton
                  onClick={() => this.props.onEdit(this.props.user)}
                  color="primary"
                  className="ml-5 float-right"
                >
                  <Edit />
                </IconButton>
              </Tooltip>
            )}
          </p>
        </div>

        <p className="mb-4">
          <span>Email</span>
          <br />
          {this.props.user.email}
        </p>
        <p className="mb-4">
          <span>Phone</span>
          <br />
          {this.props.user.telephone}
        </p>
        <p className="mb-4">
          <span>Country</span>
          <br />
          {this.props.user.country}
        </p>
        <p className="mb-4">
          <span>Town</span>
          <br />
          {this.props.user.town}
        </p>
        <p className="mb-4">
          <span>Tester Type</span>
          <br />
          {this.props.user.testerType
            ?.toString()
            .replace(/([a-z](?=[A-Z]))/g, "$1 ")}
        </p>
        {this.props.user.testerType === TesterType.EXTERNAL_TESTER && (
          <>
            <p className="mb-4">
              <span>Hourly rate</span>
              <br />
              {this.props.user.hourlyRate}
            </p>
            <p className="mb-4">
              <span>Monthly payment per bank</span>
              <br />
              {this.props.user.paymentPerBank}
            </p>
            <p className="mb-4">
              <span>Payment channel</span>
              <br />
              {this.props.user.paymentChannel}
            </p>
          </>
        )}
        <p className="mb-4">
          <span>Slack</span>
          <br />@{this.props.user.firstName} {this.props.user.lastName}
        </p>
      </div>
    );
  }
}
